import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';
import LabelForm from '../../components/LabelForm';
import InputForm from '../../components/InputForm';
import { clinicHistoryYearsHasHc, donationTypeExtraction, healthFacilities, labSectionsByHf, pdfIMSS } from '../../libs/services';
import SelectForm from '../../components/SelectForm';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');

class AutomaticWorkList extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

        this.onPrint = this.onPrint.bind(this);

		this.state = {
			health_facilities_id:"all",
			health_facilities: [],
            start_date:moment().format('YYYY-MM-DD'),
            end_date:moment().format('YYYY-MM-DD'),
            sections:[],
            lab_section_id:'all',
			data:{
                lab_section:'',
                records:[]
            },
			filename:"Reporte Listas de Trabajo Automatizadas",

			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			//health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	async componentDidMount(){
        var id = sessionStorage.getItem('health_facilities_id');
        var options = [];

        var response = await labSectionsByHf(id);
        if(response){
            options = response.map((res)=>{
                var obj = {
                    value:res.id,
                    text:res.name
                };

                return obj;
            });

            options.unshift({value:'all',text:'TODOS'});
            this.setState({sections: options});
        }

        response = await healthFacilities();
        if(response){
            options = response.map((res)=>{
                var obj = {
                    value:res.id,
                    text:res.name
                };

                return obj;
            });

            options.unshift({value:'all',text:'TODOS'});
            this.setState({health_facilities: options});
        }


		//await this.setTable();
	}


	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});
		

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	searching(){

		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					health_facilities_id: this.state.health_facilities_id,
					lab_section_id: this.state.lab_section_id,
                    start_date: this.state.start_date,
                    end_date: this.state.end_date
				}
				
                this.props.waiting.handleShow('Buscando...');
                fetch(Config.default.apiGateway.URL+'reports_imss/automated_work_list',{
                    method: 'POST',
                    body:JSON.stringify(obj),
                    headers: new Headers({
                        'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                        'Accept'		: 'application/json',
                        'Content-Type'	: 'application/json'
                    })
                }).then(res => {
                    this.props.waiting.handleClose();

                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then((msg)=>{
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(async response => {
                    if(response !== undefined){
                        this.setState({
                            data: response
                        });

                    }
                });
               
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

    onPrint(type){
        var obj = {
            health_facilities_id: this.state.health_facilities_id,
            lab_section_id: this.state.lab_section_id,
            start_date: this.state.start_date,
            end_date: this.state.end_date
        }

        if(type === 'excel'){
            this.props.printExcelReport(this.state.filename, 'automated_work_list', obj);
        }else{
            this.props.printPdfIMSSReports('automated_work_list', obj);
        }
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_automated_work_list"}  />

				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>												
                                <div className="form-group">
                                    <LabelForm text="Centro" />
                                    <SelectForm 
                                        id="health_facilities_id"
                                        value={this.state.health_facilities_id}
                                        options={this.state.health_facilities}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <LabelForm text="Sección de Laboratorio" />
                                    <SelectForm 
                                        id="lab_section_id"
                                        value={this.state.lab_section_id}
                                        options={this.state.sections}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <LabelForm text="Fecha Desde" />
                                    <InputForm 
                                        type='date'
                                        id="start_date"
                                        value={this.state.start_date}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <LabelForm text="Fecha Hasta" />
                                    <InputForm 
                                        type='date'
                                        id="end_date"
                                        value={this.state.end_date}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>
							
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
								</div>

                                <div className="col-xs-12 form-group" style={{textAlign:'right'}}>
									<button type="button" className="btn btn-default" disabled={this.state.data.records.length === 0} onClick={(e) => this.onPrint('excel')} style={{marginRight:8}}>Excel</button>
									<button type="button" className="btn btn-default" disabled={this.state.data.records.length === 0} onClick={(e) => this.onPrint('pdf')}>PDF</button>
								</div>
								<div className="col-xs-12 form-group">
									<div className='col-xs-12 form-group' style={{textAlign:'right'}}>
                                        <span><b>Area de Trabajo </b>{this.state.data.lab_section}</span>
                                    </div>
                                    {this.state.data.records.map((rec, i)=>
                                        <div key={i} className="col-xs-12 form-group" style={{border:'1px solid #eee', borderRadius:5, boxShadow:'1px 1px 5px #eee'}}>
                                            <div className='col-xs-12 col-sm-6'>
                                                <div className='col-xs-12'>
                                                    <span><b>No. Consecutivo: </b>{(i+1)}</span>
                                                </div>
                                                <div className='col-xs-12'>
                                                    <span><b>Nombre del Paciente: </b>{rec.patient}</span>
                                                </div>
                                                <div className='col-xs-12'>
                                                    <span><b>Servicio: </b>{rec.service}</span>
                                                </div>
                                            </div>
                                            <div className='col-xs-12 col-sm-6'>
                                                <div className='col-xs-12'>
                                                    <span><b>Folio: </b>{rec.folio}</span>
                                                </div>
                                                <div className='col-xs-12'>
                                                    <span><b>Fecha: </b>{moment(rec.pet_date).format('DD/MM/YYYY')}</span>
                                                </div>
                                                <div className='col-xs-12 col-sm-6'>
                                                    <span><b>Externo: </b>{rec.external}</span>
                                                </div>
                                                <div className='col-xs-12 col-sm-6'>
                                                    <span><b>Cama: </b>{rec.bed_number}</span>
                                                </div>
                                            </div>
                                            <div className='col-xs-12'>
                                                <div className='col-xs-12'>
                                                    <span><b>Diagnóstico: </b>{rec.diagnosis}</span>
                                                </div>
                                            </div>
                                            <div className='col-xs-12'>
                                                <div className='col-xs-12'>
                                                    <span><b>Estudios: </b>{rec.tests.map((test)=>test+' - ')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (AutomaticWorkList);